import React from 'react'
import { FormMultiSelectInput } from '@superhi/design'
import { useFormikContext } from 'formik'

import { API } from '../../api'
import MultiSelectSearch from '../MultiSelectSearch'

import { QUERY, SEARCH_QUERY } from './queries'

function FormMultiSelectCourseLessons(
  props: Omit<React.ComponentProps<typeof FormMultiSelectInput>, 'options'>,
) {
  return (
    <MultiSelectSearch<
      API.MultiSelectCourseLessons,
      API.MultiSelectCourseLessonsVariables,
      API.MultiSelectCourseLessons_Search,
      {}
    >
      {...props}
      query={QUERY}
      getQueryVariables={(ids) => ({ ids })}
      queryDataToOptionsFn={(data) =>
        data.courseLessons?.nodes.map((item) => ({
          value: item.id,
          display: item.title,
          href: `/course-lessons/${item.id}`,
        })) || []
      }
      searchTitle="Choose lessons"
      searchQuery={SEARCH_QUERY}
      searchCreateQueryVariablesFn={() => ({})}
      searchQueryDataToItemsFn={(data) =>
        data.courseLessons?.nodes.map((item) => ({
          id: item.id,
          children: item.title || item.id,
        })) || []
      }
    />
  )
}

export default FormMultiSelectCourseLessons
